import {
  GET_BADGES_CHILDREN,
  BADGE_CHILD_ERROR,
  CREATE_BADGE_CHILD,
  UPDATE_BADGE_CHILD,
  DELETE_BADGE_CHILD,
  GET_BADGE_CHILD,
  LOADING_BADGES_CHILDREN,
} from "../actions/types";

const initialState = {
  badgeChild: [],
  badgesChildren: [],
  tree: [], // Árvore hierárquica de badges
  loading: false,
  badgeChildError: null,
  badgeChildMessage: null,
};

// eslint-disable-next-line
export default function (state = initialState, action) {
  switch (action.type) {
    case LOADING_BADGES_CHILDREN:
      return {
        ...state,
        loading: true,
        badgeChildError: null,
      };
    case CREATE_BADGE_CHILD:
      return {
        ...state,
        badgeChild: action.payload,
      };
    case UPDATE_BADGE_CHILD:
      return {
        ...state,
        badge: action.payload,
      };
    case BADGE_CHILD_ERROR:
      return {
        ...state,
        badgeChildError: action.payload,
        loading: false,
      };
    case DELETE_BADGE_CHILD:
      return {
        ...state,
        badgeChild: action.payload,
      };
    case GET_BADGES_CHILDREN:
      return {
        ...state,
        badgesChildren: action.payload,
        tree: action.payload, // Salvar árvore completa
        loading: false,
      };
    case GET_BADGE_CHILD:
      return {
        ...state,
        badgeChild: action.payload,
      };
    default:
      return state;
  }
}